import { Row, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import IconComponent from "../../../../CommonElements/IconComponent";

const ShiftInfo = ({ dateInfo }: { dateInfo: string }) => (
  <>
    <P className="f-12 mb-1 text-uppercase">Shift Today: </P>
    <Row className="mb-2">
      <Col xs="2">
        <IconComponent className="text-center f-24 icofont icofont-wall-clock" />
      </Col>
      <Col className="ps-0" xs="8">
        <P>{dateInfo}</P>
      </Col>
    </Row>
  </>
);

export default ShiftInfo;
